import { getFirestore, doc, getDoc, setDoc } from "firebase/firestore";
import { ImageGalleryType } from "../../models/imageGallery";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { firestore, storage } from "../../firebase";
import { v4 as uuidv4 } from "uuid";



// Initialize Firestore
const IMAGES_COLLECTION_NAME = "image-collections";


const uploadImagesToStorage = async (files: File[]): Promise<string[]> => {
    const urls: string[] = [];
    
    for (const file of files) {
        // Generate hash for the file
        const fileArrayBuffer = await file.arrayBuffer();
        const hash = await crypto.subtle.digest("SHA-256", fileArrayBuffer);
        const hashString = Array.from(new Uint8Array(hash))
            .map((byte) => byte.toString(16).padStart(2, "0"))
            .join("");

        // Check if a file with this hash already exists in storage
        const existingRef = ref(storage, `gallery-images/${hashString}`);
        
        try {
            // Try to get the download URL of existing file
            const existingURL = await getDownloadURL(existingRef);
            urls.push(existingURL);
            console.log("File already exists, reusing URL:", existingURL);
        } catch (error) {
            // File doesn't exist, upload it with hash as filename
            console.log("File not found, uploading new file with hash:", hashString);
            const snapshot = await uploadBytes(existingRef, file);
            const downloadURL = await getDownloadURL(snapshot.ref);
            urls.push(downloadURL);
        }
    }
    
    return urls;
};


const getGalleryImages = async (propertyId: string): Promise<ImageGalleryType[]> => {
    try {
        const docRef = doc(firestore, IMAGES_COLLECTION_NAME, propertyId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
            console.log("Fetched images for property ID:", propertyId);
            return docSnap.data().images.map((i: any) => i as ImageGalleryType) || [];
        } else {
            console.log("No images found for property ID:", propertyId);
            return [];
        }
    } catch (error) {
        console.error("Error fetching images:", error);
        return [];
    }
};

const setGalleryImages = async (propertyId: string, images: ImageGalleryType[]) => {
    try {
        const docRef = doc(firestore, IMAGES_COLLECTION_NAME, propertyId);
        await setDoc(docRef, { images });
        console.log("Images saved for property ID:", propertyId);
    } catch (error) {
        console.error("Error saving images:", error);
    }
};

const ImageService = {
    uploadImagesToStorage,
    getGalleryImages,
    setGalleryImages,
};

export { ImageService };
